import SpeakerModal from './SpeakerModal';

export default SpeakerModal;
